import { getRegionByCookie } from '@/libs/region.js';
import { LANG_TYPE } from '@xd-rocket/attributes/src/options/lang';

// 通过域名固定语言，某些地区是特定语言无需再跳转
export function getLanguageByDomain() {
  if (typeof window === 'undefined') {
    return null;
  }
  // starforce.tw域名不走语言自动识别跳转逻辑 语言为zh_TW
  // if (window.location.href.indexOf('.starforce.tw') > -1) {
  //   return 'zh_TW';
  // }
  // TODO 越南地区逻辑
}

// com 在某些地区不能使用相应语言
export function isCanUseLanguageByDomain(language) {
  // console.log('isCanUseLanguageByDomain');
  if (typeof window === 'undefined') {
    return true;
  }
  // if (window.location.href.indexOf('xd.com') > -1 && language === 'zh_TW') {
  //   // starforce.tw 避免台湾地区使用 xd.com
  //   let region = getRegionByCookie();
  //   if (region === 'TW') {
  //     return false;
  //   }
  // }
  return true;
}

// 通过系统、网址路径、Get参数 获取语言
export function getLanguageByPath(rootPath, get) {
  // // 建站器数据池中使用
  // 默认 __default, 简体中文: zh_CN, 繁体中文: zh_TW, 英文: en_US, 泰文: th_TH, 印尼文: in_ID, 韩文: ko_KR, 日文: ja_JP, 德文: de_DE, 法文: fr_FR, 葡萄牙文: pt_PT, 西班牙文: es_ES, 土耳其文: tr_TR, 俄语: ru_RU
  // 做为多语言 Key

  let language = null;
  // let locale = this.$localStorage.get('poster:locale');
  let locale = null; // 由于 Tap 不支持 localStorage ，这里暂时不开启
  if (!locale) {
    // 1、通过网址根目录地区信息识别，测试阶段获取不到
    // let path = this.$route.params?.path; root_path
    // let path = 'es';
    if (rootPath) {
      // console.log(LANG_TYPE);
      let regionWithLanguage = {};
      let langs = JSON.parse(JSON.stringify(LANG_TYPE));
      langs.push({
        region: 'zh-tw',
        value: 'zh_TW',
      });
      langs.push({
        region: 'zh-cn',
        value: 'zh_CN',
      });
      langs.forEach((data) => {
        if (data.region) {
          regionWithLanguage[data.region] = data.value;
        }
      });
      if (regionWithLanguage[rootPath]) {
        language = regionWithLanguage[rootPath];
        // return this.updateLocale(language);
        return language;
      }
      //这里加 en 兼容地区，因为 en 并不是地球，不应在根目录出现
      if (rootPath === 'en') {
        if (typeof navigator !== 'undefined') {
          console.warn(
            '"en" is not an area identifier, please use "us", temporarily converted to "en_US".'
          );
        }
        return 'en_US';
      }
    }

    language =
      // 2.1、通过网址参数获取语言信息
      get?.language ||
      // 查看浏览器语言
      (typeof navigator !== 'undefined'
        ? navigator?.language || navigator?.browserLanguage
        : undefined);
    // console.log(language);
    // 无法获取，放弃执行
    if (!language) return null;
    // 2.2、将浏览器获取的值转换到可以识别的格式
    let lang =
      -1 !== language.indexOf('-') ? language.split('-') : language.split('_');
    if (lang[1]) lang[1] = lang[1].toUpperCase();
    language = lang.join('_');
    return language;
  }
  // this.updateLocale(locale);
  return locale;
}
export function getLanguageKey(i18nMessages, defaultLanguage) {
  let langs = JSON.parse(JSON.stringify(LANG_TYPE));
  let lang = {};
  langs.forEach((data) => {
    lang[data.value] = data;
  });
  let languages = [];
  Object.keys(i18nMessages).forEach((key) => {
    let k = key === '__default' ? defaultLanguage : key;
    languages.push(lang[k]);
  });
  languages.sort((a, b) => {
    const priority = {
      en_US: 1, // 英文
      zh_CN: 2, // 简体中文
      zh_TW: 3, // 繁体中文
    };

    const aPriority = priority[a.value] || Infinity;
    const bPriority = priority[b.value] || Infinity;

    // 如果优先级不同，按优先级排序
    if (aPriority !== bPriority) {
      return aPriority - bPriority;
    }

    // 如果优先级相同，按默认规则排序
    return a.value.localeCompare(b.value, 'en', { sensitivity: 'base' });
  });
  return languages;
}
